(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('grifo-product-rail')) {
  customElements.define('grifo-product-rail', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.grifo-product-rail');
      this.controls = this.parentElement.querySelector('.grifo-selection-controls');
      if (!this.rail || !this.controls) return;
      this.previous = this.controls.querySelector('[data-rail-prev]');
      this.next = this.controls.querySelector('[data-rail-next]');
      this.move = direction => this.rail.scrollBy({left: direction * (this.rail.clientWidth + parseFloat(getComputedStyle(this.rail).columnGap || 0)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      this.update = () => { this.previous.disabled = this.rail.scrollLeft < 2; this.next.disabled = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2; };
      this.onPrevious = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.previous.addEventListener('click', this.onPrevious);
      this.next.addEventListener('click', this.onNext);
      this.rail.addEventListener('scroll', this.update, {passive:true});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.rail);
      this.controls.hidden = false;
      this.update();
      this.onCandidateSelect = event => {
        const button = event.target.closest('[data-select-product-title]');
        if (!button || !this.contains(button)) return;
        const input = button.parentElement.querySelector('[data-candidate-title]');
        input.focus(); input.select();
        this.querySelector('.grifo-home-candidates__status').textContent = 'Nome selezionato. Copialo con ⌘C su Mac o Ctrl+C su Windows e incollalo in Prodotti scelti per la home.';
      };
      this.addEventListener('click', this.onCandidateSelect);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.onCandidateSelect);
      this.previous?.removeEventListener('click', this.onPrevious);
      this.next?.removeEventListener('click', this.onNext);
      this.rail?.removeEventListener('scroll', this.update);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grifo-editorial-a"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('grifo-daily-hero')) {
  customElements.define('grifo-daily-hero', class extends HTMLElement {
    connectedCallback() {
      const source = this.querySelector('[data-daily-photos]');
      if (!source) return;
      try { this.config = JSON.parse(source.textContent); } catch (_) { return; }
      if (!Array.isArray(this.config.photos) || !this.config.photos.length) return;
      this.image = this.querySelector('img');
      this.link = this.querySelector('.grifo-editorial__hero-image');
      this.caption = this.querySelector('.grifo-editorial__image-caption');
      if (!this.image || !this.link) return;
      this.currentIndex = Number(this.dataset.rotationIndex);
      this.dayFormatter = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit' });
      const start = /^(\d{4})-(\d{2})-(\d{2})$/.exec(this.config.start || '');
      const startStamp = start ? Date.UTC(Number(start[1]), Number(start[2]) - 1, Number(start[3])) : NaN;
      const validStart = start && Number.isFinite(startStamp) && new Date(startStamp).toISOString().slice(0, 10) === this.config.start;
      this.startDay = (validStart ? startStamp : Date.UTC(2026, 8, 21)) / 86400000;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.refresh = () => {
        clearTimeout(this.timer);
        const parts = this.dayFormatter.formatToParts(new Date());
        const value = type => Number(parts.find(part => part.type === type).value);
        const day = Date.UTC(value('year'), value('month') - 1, value('day')) / 86400000;
        const automatic = Math.floor(Math.max(0, day - this.startDay) / 3) % this.config.photos.length;
        const preview = Number(this.config.preview);
        this.showPhoto(preview > 0 ? Math.min(preview - 1, this.config.photos.length - 1) : automatic);
        if (!document.hidden && !preview) this.timer = setTimeout(this.refresh, 3600000 - Date.now() % 3600000 + 100);
      };
      document.addEventListener('visibilitychange', this.refresh, options);
      window.addEventListener('pageshow', this.refresh, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.config.photos.findIndex(photo => photo.id === event.detail.blockId);
        if (index >= 0) { clearTimeout(this.timer); this.showPhoto(index); }
      }, options);
      document.addEventListener('shopify:block:deselect', this.refresh, options);
      this.refresh();
    }
    showPhoto(index) {
      if (index === this.currentIndex) return;
      const photo = this.config.photos[index];
      if (!photo) return;
      this.image.srcset = photo.srcset;
      this.image.src = photo.src;
      this.image.width = photo.width;
      this.image.height = photo.height;
      this.image.alt = photo.alt || '';
      if (photo.link) this.link.setAttribute('href', photo.link);
      else this.link.removeAttribute('href');
      this.link.setAttribute('aria-label', photo.alt || '');
      if (this.caption) this.caption.textContent = photo.caption || '';
      this.currentIndex = index;
      this.dataset.rotationIndex = String(index);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.events) this.events.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grifo-promo-x25"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('grifo-x25-banner')) {
  customElements.define('grifo-x25-banner', class extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);
      this.updateCountdown();
      if (Number.isFinite(this.end) && this.end > Date.now()) this.tick = setInterval(() => this.updateCountdown(), 1000);
    }
    disconnectedCallback() { clearInterval(this.tick); }
    updateCountdown() {
      if (!Number.isFinite(this.end)) { this.querySelector('.x25-clock').hidden = true; return; }
      const left = Math.max(0, this.end - Date.now());
      if (!left) { clearInterval(this.tick); if (this.dataset.editor !== 'true') { this.hidden = true; this.style.display = 'none'; } }
      const minutes = Math.floor(left / 60000);
      const values = [Math.floor(minutes / 1440), Math.floor(minutes / 60) % 24, minutes % 60];
      ['days', 'hours', 'minutes'].forEach((unit, i) => {
        const el = this.querySelector('[data-' + unit + ']');
        const value = String(values[i]).padStart(2, '0');
        if (el && el.textContent !== value) el.textContent = value;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
